import { ConfirmDialog } from '@/components/Account/ConfirmDialog';
import type { FC } from 'react';

interface UnsubscribeConfirmDialogProps {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
  onUnsubscribe: () => void;
  mainText: string;
  subText: string;
  confirmText: string;
}

export const UnsubscribeConfirmDialog: FC<UnsubscribeConfirmDialogProps> = ({
  showDialog,
  setShowDialog,
  onUnsubscribe,
  mainText,
  subText,
  confirmText,
}) => {
  return (
    <ConfirmDialog
      showDialog={showDialog}
      setShowDialog={setShowDialog}
      onConfirm={onUnsubscribe}
      mainText={mainText}
      subText={subText}
      confirmText={confirmText}
    />
  );
};
